import React from 'react'
import clsx from 'clsx'
import { IconButton, useTheme } from '@mui/material'
import { Trash } from 'iconsax-react'

import CustomFieldInput from '../../CustomFieldInput'

import useStyles from './styles'

export type CustomFieldTableRowProps = {
  table: LocalCustomField
  cells: APIMeta[]
  meta: APIMeta[]
  fields: LocalCustomField[]
  canEdit: boolean
  handleValueChange: (
    e: any,
    field: LocalCustomField,
    row: number,
    rowKey: string,
    parent: LocalCustomField
  ) => void
  onBlur: () => void
  deleteRow: (tableID: string, row: number) => void
}

const CustomFieldTableRow: React.FC<CustomFieldTableRowProps> = ({
  table,
  cells,
  meta,
  fields,
  canEdit,
  handleValueChange,
  onBlur,
  deleteRow
}) => {
  const theme = useTheme()

  const classes = useStyles()

  return (
    <tr>
      <td
        className={clsx(
          classes.actionCell,
          canEdit ? null : classes.deleteIconDisabled
        )}
        style={{ width: 'auto', padding: 0 }}
      >
        <IconButton onClick={() => deleteRow(table.id, cells[0]?.row)}>
          <Trash
            size={theme.size.base}
            variant='Bulk'
            className={classes.deleteIcon}
          />
        </IconButton>
      </td>

      {cells.map((cellData, cellIndex) => {
        const field = fields.find(field => field.id === cellData.row_key)

        return (
          <td key={`${table.id}-${field.id}-${cellIndex}`}>
            <CustomFieldInput
              field={field}
              value={
                meta.find(
                  data =>
                    data.key === table.id &&
                    data.row_key === cellData.row_key &&
                    data.row === cellData.row
                )?.value ?? ''
              }
              disabled={!canEdit}
              canEdit={canEdit}
              handleChange={handleValueChange}
              handleBlur={onBlur}
              row={cellData.row}
              rowKey={cellData.row_key}
              parent={table}
              meta={meta}
              task
              inputOnly
              inTable
              // TODO: Add field filtering to tables
              // shouldFilter
            />
          </td>
        )
      })}
    </tr>
  )
}

export default CustomFieldTableRow
